"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImpressionId = void 0;
const getImpressionId = (impressionUrl = '') => {
    const impressionBase64 = impressionUrl.match(/(e=)\w+/);
    if (!impressionBase64) {
        return null;
    }
    try {
        const strippedParameter = impressionBase64[0].split('=')[1];
        const parsedDecodedBase64 = JSON.parse(atob(strippedParameter));
        return parsedDecodedBase64.di;
    }
    catch (error) {
        return null;
    }
};
exports.getImpressionId = getImpressionId;
//# sourceMappingURL=impression.util.js.map